import {
  Box,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography
} from '@mui/material';
import { ChangeEvent } from 'react';

interface FormikRadioButtonProps {
  disabled?: boolean;
  label: string;
  fieldValue: {
    value: string | boolean;
  };
  options: { label: string; value: string | boolean }[];
  handleChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const FormikRadioButton = ({
  disabled = false,
  label,
  fieldValue,
  options,
  handleChange
}: FormikRadioButtonProps) => {
  return (
    <Box className="appointment-dropdown">
      <Typography variant="body1" component="div" sx={{ mb: 0.25, lineHeight: 1.3 }}>
        {label}
      </Typography>
      <RadioGroup
        name="emergencyRoadOpening"
        onChange={handleChange}
        value={fieldValue.value}
        row
        sx={{
          mt: 0,
          gap: 0,
          '& .MuiFormControlLabel-root': { mr: 2, my: 0 }
        }}
      >
        {options.map((option) => (
          <FormControlLabel
            key={option.label}
            value={option.value}
            control={<Radio disabled={disabled} />}
            label={option.label}
          />
        ))}
      </RadioGroup>
    </Box>
  );
};
